/*
 * JavaScript Pretty Date
 * Copyright (c) 2011 John Resig (ejohn.org)
 * Licensed under the MIT and GPL licenses.
 */

import IvicosStrings from 'kits/language/stringKit';

// Takes an ISO time and returns a string representing how
// long ago the date represents.
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const prettyDate = (date: Date) => {
    const diff = (new Date().getTime() - date.getTime()) / 1000,
        day_diff = Math.floor(diff / 86400);

    if (isNaN(day_diff) || day_diff < 0) return;

    return (
        (day_diff == 0 &&
            ((diff < 60 && IvicosStrings.justNowTitle) ||
                (diff < 120 && IvicosStrings.oneMinutePassedTitle) ||
                (diff < 3600 && IvicosStrings.minutesPassedTitle.replace('{quantity}', Math.floor(diff / 60).toString())) ||
                (diff < 7200 && IvicosStrings.oneHourPassedTitle) ||
                (diff < 86400 && IvicosStrings.hoursPassedTitle.replace('{quantity}', Math.floor(diff / 3600).toString())))) ||
        (day_diff == 1 && IvicosStrings.yesterdayTitle) ||
        (day_diff < 7 && IvicosStrings.daysPassedTitle.replace('{quantity}', day_diff.toString())) ||
        (day_diff < 31 && IvicosStrings.weeksPassedTitle.replace('{quantity}', Math.floor(day_diff / 7).toString())) ||
        (day_diff < 365 && IvicosStrings.monthsPassedTitle.replace('{quantity}', Math.floor(day_diff / 31).toString())) ||
        (day_diff < 730 && IvicosStrings.aYearPassedTitle) ||
        (day_diff < 730 && IvicosStrings.yearsPassedTitle.replace('{quantity}', Math.floor(day_diff / 365).toString()))
    );
};
